module.exports = __webpack_public_path__ + "img/svg/pizza-stats.60eec01ca9589b27b3f5abc8a56b7b35.svg";